export const NOTIFICATION_LIST = 'NOTIFICATION_LIST'
export const NOTIFICATION_LOADER = 'NOTIFICATION_LOADER'
